import { MonitoredRoute } from 'App'
import { CompanyType } from 'context/authentication/Company.types'
import { Role } from 'context/authentication/Role.types'
import { hasAccess, isCompanyType } from 'global/helpers/authorization'
import { type ReactNode } from 'react'
import { Redirect, type RouteProps } from 'react-router-dom'

interface AdminRouteProps extends RouteProps {
  readonly operatorOnly?: boolean
  readonly children: ReactNode
}

const AdminRoute = ({
  operatorOnly,
  children,
  ...rest
}: AdminRouteProps): ReactNode => {
  const isAdmin = hasAccess(Role.Admin)
  const isOperatorAdmin = isAdmin && isCompanyType(CompanyType.Operator)

  return (
    <MonitoredRoute
      {...rest}
      render={() => {
        if (!isAdmin || (operatorOnly && !isOperatorAdmin)) {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: location },
              }}
            />
          )
        }
        return children
      }}
    />
  )
}

export default AdminRoute
